/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.AdpIntegration {
    angular.module("meevo.plugins.adpIntegration", []);
}